import DOMPurify from 'isomorphic-dompurify';

const ALLOWED_IFRAME_DOMAINS = [
  'youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
  'youtu.be',
  'player.vimeo.com',
];

function isAllowedIframeSrc(src: string): boolean {
  if (!src) return false;
  try {
    const url = new URL(src.startsWith('//') ? `https:${src}` : src, 'https://localhost');
    const hostname = url.hostname.toLowerCase();
    return ALLOWED_IFRAME_DOMAINS.some(
      (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
}

// Strictly sanitize <iframe> elements so only verified video platforms can be embedded
DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'iframe') {
    const el = node as Element;
    const src = typeof el.getAttribute === 'function' ? el.getAttribute('src') || '' : '';
    if (!isAllowedIframeSrc(src)) {
      node.parentNode?.removeChild(node);
    }
  }
});

/**
 * Sanitizes HTML content on both server-side (SSR) and client-side.
 * isomorphic-dompurify runs DOMPurify against a jsdom instance on the
 * server, so merchant-supplied rich text (product/category/page HTML) is
 * never sent to the browser unsanitized.
 * Allows safe responsive YouTube and Vimeo video iframes.
 */
export function safeSanitize(html: string): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'scrolling',
      'src',
      'width',
      'height',
      'title',
      'loading',
      'target',
    ],
  });
}

